import { ALPHA_2_ISO_3166, ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166, GENDERS, SCHUFA_CONSENT } from 'cpool-constants';
import { z } from 'zod';

import {
    schemaConsorsCity,
    schemaConsorsDateYYYYMMDD,
    schemaConsorsFirstLastName,
    schemaConsorsStreet,
} from '../LoanRequest/Consors';

const NUMERIC_ISO_3166 = Object.values(ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166);

const countryScheme = z
    .union([z.nativeEnum(ALPHA_2_ISO_3166), z.enum([NUMERIC_ISO_3166[0]!, ...NUMERIC_ISO_3166.slice(1)])]) // workaround to create a NUMERIC-ISO-3166 enum
    .transform((val) => {
        if (NUMERIC_ISO_3166.includes(val as any)) return val;
        const key = val as keyof typeof ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166;
        return ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166[key]
            ? ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166[key]
            : ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166.DE;
    });

export const schemaConsorsSchufaRequestEntry = z.object({
    birthDate: schemaConsorsDateYYYYMMDD,
    birthPlace: schemaConsorsCity.optional(),
    consent: z.nativeEnum(SCHUFA_CONSENT),
    currentAddress: z.object({
        city: schemaConsorsCity,
        country: countryScheme.optional(),
        postalCode: z
            .string()
            .min(5)
            .max(5)
            .refine(
                (val) => {
                    return /^[0-9]+$/.test(val);
                },
                { message: 'Invalid characters' },
            ),
        street: schemaConsorsStreet,
    }),
    firstName: schemaConsorsFirstLastName,
    gender: z.nativeEnum(GENDERS),
    previousAddress: z
        .object({
            city: schemaConsorsCity,
            country: countryScheme.optional(),
            postalCode: z
                .string()
                .min(5)
                .max(5)
                .refine(
                    (val) => {
                        return /^[0-9]+$/.test(val);
                    },
                    { message: 'Invalid characters' },
                ),
            street: schemaConsorsStreet,
        })
        .optional(),
    referenceId: z.string().min(1),
    surname: schemaConsorsFirstLastName,
});
export type SchemaConsorsSchufaRequestEntry = z.infer<typeof schemaConsorsSchufaRequestEntry>;

export const schemaConsorsSchufaRequest = z.object({
    personList: z.array(schemaConsorsSchufaRequestEntry),
});

export type SchemaConsorsSchufaRequest = z.infer<typeof schemaConsorsSchufaRequest>;
